import styled from "styled-components";

export const StyledTableWrapper = styled.div`
  height: 100%;
  width: 100%;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.32);
`;
